import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon, LogOutIcon, UserIcon } from 'lucide-react';
export function VendorHeader({
  vendor,
  onLogout
}) {
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const profileMenuRef = useRef(null);
  const profileButtonRef = useRef(null);
  // Close profile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (profileMenuOpen && !profileButtonRef.current?.contains(event.target) && !profileMenuRef.current?.contains(event.target)) {
        setProfileMenuOpen(false);
      }
    };
    if (profileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [profileMenuOpen]);
  const toggleProfileMenu = () => {
    setProfileMenuOpen(!profileMenuOpen);
  };
  // Early return if vendor is not available
  if (!vendor) {
    return <header className="bg-white shadow" data-id="element-1186">
        <div className="w-full mx-auto px-4 py-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-1187">
          <div className="flex items-center" data-id="element-1188">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6TfLnmLX2evxxxZK6TYFtj/Rapid_P2P_-_Blue-Green.svg" alt="RapidP2P Logo" className="h-10" data-id="element-1189" />
            <span className="ml-3 text-lg font-medium text-gray-900" data-id="element-1190">
              Vendor Portal
            </span>
          </div>
        </div>
      </header>;
  }
  const vendorInitial = vendor.name ? vendor.name.charAt(0) : '?';
  const vendorDisplayName = vendor.name || 'Unknown Vendor';
  const vendorEmail = vendor.email || '';
  return <header className="bg-white shadow" data-id="element-1191">
      <div className="w-full mx-auto px-4 py-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-1192">
        <div className="flex items-center" data-id="element-1193">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6TfLnmLX2evxxxZK6TYFtj/Rapid_P2P_-_Blue-Green.svg" alt="RapidP2P Logo" className="h-10" data-id="element-1194" />
          <span className="ml-3 text-lg font-medium text-gray-900" data-id="element-1195">
            Vendor Portal
          </span>
        </div>
        <div className="flex items-center space-x-4" data-id="element-1196">
          <div className="relative" data-id="element-1197">
            <button ref={profileButtonRef} onClick={toggleProfileMenu} className="flex items-center space-x-2 focus:outline-none" data-id="element-1198">
              <div className="h-8 w-8 rounded-full bg-indigo-600 flex items-center justify-center text-white text-sm" data-id="element-1199">
                {vendorInitial}
              </div>
              <span className="text-sm text-gray-500" data-id="element-1200">{vendorDisplayName}</span>
              <ChevronDownIcon className="h-4 w-4 text-gray-500" data-id="element-1201" />
            </button>
            {profileMenuOpen && <div ref={profileMenuRef} className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 ring-1 ring-black ring-opacity-5" data-id="element-1202">
                <div className="px-4 py-2 text-xs text-gray-500 border-b border-gray-100" data-id="element-1203">
                  {vendorEmail}
                </div>
                <a href="#" onClick={e => {
              e.preventDefault();
              setProfileMenuOpen(false);
            }} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" data-id="element-1204">
                  <UserIcon className="h-4 w-4 mr-2 text-gray-500" data-id="element-1205" />
                  Profile Settings
                </a>
                <button onClick={onLogout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" data-id="element-1206">
                  <LogOutIcon className="h-4 w-4 mr-2 text-gray-500" data-id="element-1207" />
                  Sign Out
                </button>
              </div>}
          </div>
        </div>
      </div>
    </header>;
}